// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__uKIKQ","header":"Messages_header__1PCP9"};